import React from 'react'
import NotificationComp from './NotificationComp'

const Notificaton = () => {
  return (
    <>
        <NotificationComp/> 
    </>
  )
}

export default Notificaton